module.exports = __webpack_public_path__ + "static/media/boxOnInclinedPlane1.e9d1c38a.svg";